import { render } from "./Unit.vue?vue&type=template&id=84a81272&scoped=true"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"

import "./Unit.vue?vue&type=style&index=0&id=84a81272&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a81272"]])

export default __exports__